import Base from './base'
import { SearchResultResponse, SearchParams } from '../types/search'

export default class Search extends Base {
  async searchResult(params: SearchParams): Promise<SearchResultResponse> {
    return this.api.get('search_result', { params })
  }
}
